// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dropdownColor {
  background-color: #fbb062; /* Brand Warm Orange */
  border-color: #fbb062;
}

.d-block {
  display: block;
}

.content_Fit {
  padding: calc(80px + 1.25rem) 0.625rem 160px;
}

.ml-1 {
  margin-left: 10px;
}

.mright-1 {
  margin-right: 10px;
}
.h-4 {
  height: 45px !important;
}

.pagination {
  display: flex;
  justify-content: flex-start;
}

.color-red {
  color: red;
  font-weight: 600;
}

.color-green {
  color: green;
  font-weight: 600;
}
.title-color {
  color: #fbb062; /* Brand Warm Orange */
}
.cursor-pointer {
  cursor: pointer !important;
}
.button-color {
  background-color: #fbb062; /* Brand Warm Orange */
  color: #fff;
  border: none;
}

.button-color:hover {
  background-color: #a45139 !important; /* Brand Rust Brown */
}

.modal-dialog {
  max-width: 550px;
}
.error_msg {
  font-size: 12px;
  text-align: center;
  color: #ed193b;
}
.page-content .react-tel-input .form-control {
  width: 100%;
}
.descriptionBox {
  border: 1px solid #e2e2e2;
  padding: 4px 6px;
  min-height: 70px;
  color: #74788d;
  background-color: #ece9de;
  border-radius: 6px;
} /* Brand Light Cream */
.activeBadge {
  font-weight: 600;
  color: rgb(47, 104, 70);
  font-size: 13px;
  line-height: 1.43;
  background: rgb(234, 251, 231);
  padding: 4px 8px;
  border-radius: 4px;
}
.inActiveBadge {
  font-weight: 600;
  color: rgb(237 25 59);
  font-size: 13px;
  line-height: 1.43;
  background: rgb(237, 25, 59, 0.06);
  padding: 4px 8px;
  border-radius: 4px;
}
.clickableLabel {
  text-transform: capitalize;
  cursor: pointer;
}
.clickableLabel:hover {
  text-decoration: underline;
  color: #a45139;
} /* Brand Rust Brown */

.react-tagsinput-input {
  width: 100% !important;
}

body.modal-open {
  padding-right: 0 !important;
}
`, "",{"version":3,"sources":["webpack://./src/app.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB,EAAE,sBAAsB;EACjD,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,cAAc,EAAE,sBAAsB;AACxC;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,yBAAyB,EAAE,sBAAsB;EACjD,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oCAAoC,EAAE,qBAAqB;AAC7D;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;AACpB,EAAE,sBAAsB;AACxB;EACE,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,0BAA0B;EAC1B,eAAe;AACjB;AACA;EACE,0BAA0B;EAC1B,cAAc;AAChB,EAAE,qBAAqB;;AAEvB;EACE,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;AAC7B","sourcesContent":[".dropdownColor {\n  background-color: #fbb062; /* Brand Warm Orange */\n  border-color: #fbb062;\n}\n\n.d-block {\n  display: block;\n}\n\n.content_Fit {\n  padding: calc(80px + 1.25rem) 0.625rem 160px;\n}\n\n.ml-1 {\n  margin-left: 10px;\n}\n\n.mright-1 {\n  margin-right: 10px;\n}\n.h-4 {\n  height: 45px !important;\n}\n\n.pagination {\n  display: flex;\n  justify-content: flex-start;\n}\n\n.color-red {\n  color: red;\n  font-weight: 600;\n}\n\n.color-green {\n  color: green;\n  font-weight: 600;\n}\n.title-color {\n  color: #fbb062; /* Brand Warm Orange */\n}\n.cursor-pointer {\n  cursor: pointer !important;\n}\n.button-color {\n  background-color: #fbb062; /* Brand Warm Orange */\n  color: #fff;\n  border: none;\n}\n\n.button-color:hover {\n  background-color: #a45139 !important; /* Brand Rust Brown */\n}\n\n.modal-dialog {\n  max-width: 550px;\n}\n.error_msg {\n  font-size: 12px;\n  text-align: center;\n  color: #ed193b;\n}\n.page-content .react-tel-input .form-control {\n  width: 100%;\n}\n.descriptionBox {\n  border: 1px solid #e2e2e2;\n  padding: 4px 6px;\n  min-height: 70px;\n  color: #74788d;\n  background-color: #ece9de;\n  border-radius: 6px;\n} /* Brand Light Cream */\n.activeBadge {\n  font-weight: 600;\n  color: rgb(47, 104, 70);\n  font-size: 13px;\n  line-height: 1.43;\n  background: rgb(234, 251, 231);\n  padding: 4px 8px;\n  border-radius: 4px;\n}\n.inActiveBadge {\n  font-weight: 600;\n  color: rgb(237 25 59);\n  font-size: 13px;\n  line-height: 1.43;\n  background: rgb(237, 25, 59, 0.06);\n  padding: 4px 8px;\n  border-radius: 4px;\n}\n.clickableLabel {\n  text-transform: capitalize;\n  cursor: pointer;\n}\n.clickableLabel:hover {\n  text-decoration: underline;\n  color: #a45139;\n} /* Brand Rust Brown */\n\n.react-tagsinput-input {\n  width: 100% !important;\n}\n\nbody.modal-open {\n  padding-right: 0 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
